import {Box, Step, StepContent, StepLabel, Stepper, Typography} from "@mui/material";
import React from "react";

function Steps() {
    return (
        <Box>
            <Typography variant="h4" mt={"0.5em"} mx={"0.25em"} gutterBottom>
                Schritt für Schritt
            </Typography>
            <Box mx={"0.5em"} mt={"1em"}>
                <Stepper orientation="vertical">
                    <Step
                        key={0}
                        active={true}
                        completed={false}
                    >
                        <StepLabel>
                            <Typography variant="caption">Schritt 1</Typography>
                        </StepLabel>
                        <StepContent>
                            <Typography variant="body1">Lorem ipsum</Typography>
                        </StepContent>
                    </Step>
                    <Step
                        key={1}
                        active={true}
                        completed={false}
                    >
                        <StepLabel>
                            <Typography variant="caption">Schritt 2</Typography>
                        </StepLabel>
                        <StepContent>
                            <Typography variant="body1">Lorem ipsum</Typography>
                        </StepContent>
                    </Step>
                </Stepper>
            </Box>
        </Box>
    );
}

export default Steps;